/**
 * Shop page tab switching and card shuffling.
 * - Tabs sync to the URL hash (#by-talent / #by-type / #by-event) so views are
 *   deep-linkable and survive refresh/back.
 * - Arrow-key navigation on the tablist (ARIA tabs pattern).
 * - Optional collection-card shuffling, only when the merchant enables the
 *   "Display talents in random order" section setting (data-shuffle).
 */
(function() {
  /* ── Tab switching ── */
  var tabButtons = document.querySelectorAll('.shop-page__tab-btn');
  var tabPanels = document.querySelectorAll('.shop-page__tab-panel');
  var hasTabs = tabButtons.length > 0 && tabPanels.length > 0;

  var HASHES = { vtuber: '#by-talent', type: '#by-type', event: '#by-release' };

  /* Custom tab blocks carry their own hash (handleized label) so they're
     deep-linkable too, e.g. /collections#by-originals */
  tabButtons.forEach(function(btn) {
    var customHash = btn.getAttribute('data-tab-hash');
    if (customHash) HASHES[btn.getAttribute('data-tab')] = '#' + customHash;
  });

  function activate(button, updateHash) {
    var targetTab = button.getAttribute('data-tab');

    tabButtons.forEach(function(btn) {
      var isTarget = btn === button;
      btn.classList.toggle('is-active', isTarget);
      btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      btn.setAttribute('tabindex', isTarget ? '0' : '-1');
    });

    tabPanels.forEach(function(panel) {
      var isTarget = panel.id === 'tab-' + targetTab;
      panel.classList.toggle('is-active', isTarget);
      panel.hidden = !isTarget;
    });

    if (updateHash && HASHES[targetTab]) {
      /* replaceState keeps Back for page navigation, not per-tab-click */
      history.replaceState(null, '', HASHES[targetTab]);
    }
  }

  if (hasTabs) {
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        activate(button, true);
      });
    });

    /* Arrow-key navigation per the ARIA tabs pattern */
    var tablist = document.querySelector('.shop-page__tab-buttons');
    if (tablist) {
      tablist.addEventListener('keydown', function(e) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;

        var buttons = Array.prototype.slice.call(tabButtons);
        var current = buttons.indexOf(document.activeElement);
        if (current === -1) return;

        var next = current;
        if (e.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
        if (e.key === 'ArrowRight') next = (current + 1) % buttons.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = buttons.length - 1;

        e.preventDefault();
        buttons[next].focus();
        activate(buttons[next], true);
      });
    }

    /* Restore the tab from the URL hash on load */
    function tabFromHash() {
      var hash = window.location.hash;
      for (var key in HASHES) {
        if (HASHES[key] === hash) {
          for (var i = 0; i < tabButtons.length; i++) {
            if (tabButtons[i].getAttribute('data-tab') === key) return tabButtons[i];
          }
        }
      }
      return null;
    }

    var initial = tabFromHash();
    if (initial) {
      activate(initial, false);
    } else {
      /* Ensure roving tabindex is initialized even on the default tab */
      tabButtons.forEach(function(btn) {
        btn.setAttribute('tabindex', btn.classList.contains('is-active') ? '0' : '-1');
      });
    }

    /* The section's inline pre-paint script may have force-shown the hash
       tab's panel via CSS to avoid a default-tab flash; real state is
       applied now, so the override must go or it would pin that panel
       visible across future tab switches. */
    var prepaint = document.getElementById('shop-tabs-prepaint');
    if (prepaint) prepaint.parentNode.removeChild(prepaint);

    /* Respond to hash changes (e.g. nav links to /collections#by-event) */
    window.addEventListener('hashchange', function() {
      var btn = tabFromHash();
      if (btn) activate(btn, false);
    });
  }

  /* ── Shuffle collection cards (opt-in via section setting) ── */
  function shuffleChildren(container) {
    if (!container) return;
    var children = Array.from(container.children);
    if (children.length < 2) return;

    /* Fisher-Yates shuffle */
    for (var i = children.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = children[i];
      children[i] = children[j];
      children[j] = temp;
    }

    children.forEach(function(child) {
      container.appendChild(child);
    });
  }

  ['.shop-page__vtuber-featured', '.shop-page__vtuber-all'].forEach(function(selector) {
    var grid = document.querySelector(selector);
    if (grid && grid.hasAttribute('data-shuffle')) shuffleChildren(grid);
  });

})();
